import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';

@Component({
  selector: 'app-page-create-datetime-type',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgbModule],
  templateUrl: './page-create-datetime-type.component.html',
  styleUrl: './page-create-datetime-type.component.scss',
  providers: [CommonService]
})

export class PageCreateDatetimeTypeComponent extends BaseHttpReqRespService implements OnInit {
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  questionDateTimeTypeForm!: FormGroup;
  public folderName!: string;
  myAppUrl: any;
  questionlist: any;
  QuestionId: any;
  successOrFailureMessage: string = '';
  public questionId!: number;
  public folderId!: number;
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  quesCategoryForm!: FormGroup;
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;

  @ViewChild('CreateUpdateQsCategoryModal') categoryModal!: TemplateRef<any>;

  constructor
    (@Inject(OKTA_AUTH) private oauth: OktaAuth,
      @Inject('BASE_URL') baseUrl: string,
      @Inject('CONFIG_SETTINGS') configSettings: any,
      private _router: Router,
      public http: HttpClient,
      private modalService: NgbModal,
      private formBuilder: FormBuilder,
      private commonService: CommonService,
      private route: ActivatedRoute,
      private renderer: Renderer2,
      private EncrDecr: EncrDecrService
    ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl += '/';
  }


  backUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      let fId = this.folderId;
      let fName = this.folderName;
      if (fId > 0)
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: fId, question: fName } });
      else
        this._router.navigate(['question']);
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }

  backToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }


  ngOnInit() {
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];


    this.questionDateTimeTypeForm = this.formBuilder.group({
      questionDescription: ['', [Validators.required]],
      questionCategoryId: new FormControl(''),
      shortName: new FormControl('')
    });
    this.questionId = + this.route.snapshot.queryParams["questionId"];
    this.folderId = + this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];


    this.getDescriptionQuestionDeatils(this.questionId, this.folderId);
    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestionCategoryList();
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  getDescriptionQuestionDeatils(questionId: any, folderId: any) {
    const url = `${this.myAppUrl}${this.QUESTION_ENDPOINT.DETAILS}?questionId=${questionId}&folderId=${folderId}`;
    this.commonService.httpGet("", url).subscribe(
      response => {

        this.questionDateTimeTypeForm.patchValue({
          questionDescription: response.question,
          questionCategoryId: response.questionCategoryId,
          shortName: response.shortName,
        });

      }, error => {

        console.log(error);
      }
    );
  }

  public savequestionDescription() {
    let questionId = +this.route.snapshot.queryParams["questionId"];
    let folderId = +this.route.snapshot.queryParams["folderId"];
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? "0");
    const payload = {
      question: this.questionDateTimeTypeForm.value.questionDescription,
      questionCategoryId: this.questionDateTimeTypeForm.value.questionCategoryId,
      shortName: this.questionDateTimeTypeForm.value.shortName,
      createdBy: userId ? Number(userId) : null, // <-- Ensure this is a number or null
      questionId: questionId,
      folderId: folderId
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
    };

    this.commonService.httpPostWOHeader(
      this.myAppUrl + this.QUESTION_ENDPOINT.SAVE_DATE_TIME_QUESTION,
      JSON.stringify(payload),
      httpOptions
    ).subscribe(
      questionId => {
        this.successOrFailureMessage = "Date Type Question  Saved Successfully";
        setTimeout(() => {
          this.successOrFailureMessage = '';
          this.folderId = +this.route.snapshot.queryParams["folderId"];
          this.folderName = this.route.snapshot.queryParams["folderName"];
          var location = window.location.pathname;
          if (location.includes("/client") == false) {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
          else {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
        }, 2000);
      }, error => console.error(error));
  }

  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
        this.successOrFailureMessage = '';
      }, 1200);
    }, error => console.error(error));

  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}
